const style = {
  container: {
    width: "100%",
    padding: "20px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "40px",
  },
  title: {
    fontSize: "32px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: "#8B949E",
    margin: 0,
  },
  addButton: {
    backgroundColor: "#58A6FF",
    color: "#0D1117",
    border: "none",
    borderRadius: "8px",
    padding: "12px 20px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    transition: "opacity 0.2s ease",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    marginBottom: "40px",
  },
  statCard: {
    backgroundColor: "rgba(22, 27, 34, 0.5)",
    border: "1px solid #30363D",
    borderRadius: "12px",
    padding: "20px",
  },
  statLabel: {
    fontSize: "14px",
    color: "#8B949E",
    margin: "0 0 8px 0",
  },
  statValue: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#E6EDF3",
    margin: 0,
  },
  listContainer: {
    backgroundColor: "rgba(22, 27, 34, 0.8)",
    border: "1px solid #30363D",
    borderRadius: "16px",
    overflow: "hidden",
  },
  filtersContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    borderBottom: "1px solid #30363D",
  },
  searchInput: {
    flex: 1,
    maxWidth: "350px",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "8px",
    padding: "10px 16px",
    fontSize: "14px",
    color: "#E6EDF3",
    outline: "none",
  },
  statusFilterGroup: {
    display: "flex",
  },
  statusButton: {
    background: "transparent",
    border: "none",
    color: "#8B949E",
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "14px",
    borderRadius: "6px",
    marginLeft: "8px",
    transition: "background-color 0.2s ease, color 0.2s ease",
  },
  statusButtonActive: {
    backgroundColor: "rgba(88, 166, 255, 0.2)",
    color: "#E6EDF3",
  },
  platformList: {
    display: "flex",
    flexDirection: "column",
  },
  listHeaderRow: {
    color: "#8B949E",
    fontSize: "12px",
    textTransform: "uppercase",
    fontWeight: "600",
    borderBottom: "1px solid #30363D",
  },
  platformRow: {
    display: "grid",
    gridTemplateColumns: "3fr 2fr 2fr 2fr",
    alignItems: "center",
    padding: "16px 24px",
    borderBottom: "1px solid #30363D",
    transition: "background-color 0.2s ease",
    gap: 30
  },
  platformCell: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    display: "flex",
    justifyContent: "start"
  },
  cellName: {
    flex: 3,
    minWidth: "300px",
  },
  cellStatus: {
    flex: 1,
    minWidth: "120px",
  },
  cellSubs: {
    flex: 1,
    justifyContent: "center",
    minWidth: "100px",
    color: "#E6EDF3",
    fontWeight: "500",
  },
  cellRevenue: {
    flex: 1,
    justifyContent: "center",
    minWidth: "150px",
    color: "#E6EDF3",
    fontWeight: "500",
  },
  cellAction: {
    flex: 1,
    justifyContent: "flex-end",
    minWidth: "100px",
  },
  platformIcon: {
    fontSize: "24px",
    marginRight: "16px",
  },
  platformName: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#E6EDF3",
    margin: 0,
  },
  platformVersion: {
    fontSize: "12px",
    color: "#8B949E",
    margin: "2px 0 0 0",
  },
  statusBadge: {
    padding: "4px 12px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "600",
    whiteSpace: "nowrap",
  },
  statusAvailable: {
    backgroundColor: "rgba(4, 120, 87, 0.3)",
    color: "#34D399",
  },
  statusBlocked: {
    backgroundColor: "rgba(153, 27, 27, 0.3)",
    color: "#F87171",
  },
  actionButton: {
    backgroundColor: "rgba(88, 166, 255, 0.2)",
    color: "#58A6FF",
    border: "1px solid rgba(88, 166, 255, 0.5)",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "13px",
    transition: "background-color 0.2s ease",
  },
  noResults: {
    color: "#8B949E",
    textAlign: "center",
    padding: "40px",
    fontSize: "16px",
  },
  paginationControls: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 24px',
    borderTop: '1px solid #30363D',
    color: '#8B949E',
    gap: '16px',
    fontSize: '14px',
    fontWeight: '500',
  },
  paginationButton: {
    background: 'transparent',
    border: '1px solid #30363D',
    color: '#8B949E',
    borderRadius: '6px',
    padding: '8px 16px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'background-color 0.2s ease, color 0.2s ease',
  },
  paginationButtonDisabled: {
    background: 'transparent',
    border: '1px solid #222831',
    color: '#484f58',
    borderRadius: '6px',
    padding: '8px 16px',
    cursor: 'not-allowed',
    fontWeight: '600',
  },
};

export default style;